import { Dropdown } from "primeng/dropdown";
import { TrackExpenseDetail } from "./track-expense.model";

export class ExpenseCard{
  id:number;
  name:string;
  expenseDate: Date;
  icon:string;
  iconColor:string
  attachmentCount: number;
  amount:number;
  type:string;
  textColor:string
  is_voilated:boolean;
  reason:string;
  added_on:any;
  added_by:Dropdown;
  compliance_status:Dropdown;
  expense_bucket:Dropdown;
  expense_bucket_category:any;
  expense_status:Dropdown;
  expense_type:any;
  report:any;
  transaction:any;
  merchant_name:string;
  recoverable: any;
  note: any;
  expense_meta:any;
  verifier_name:string;
  approver_name:string;
  expense_attachments:any[]=[]
  is_track_expense:boolean=false;
  track_expense_detail = new TrackExpenseDetail()
  extra_fields_data:any;
  transaction_datetime:null;
  is_upi:boolean=false;
  is_tax_included:boolean=false;
  base_amount:number=0;
  expense_tax_data=[];
  // constructor() {
  //   this.id = 0
  //   this.name = null
  //   this.expenseDate = null
  //   this.icon = null
  //   this.attachmentCount = 0
  //   this.amount = 0
  //   this.type = null
  //   this.textColor =""
  //   this.iconColor=""
  // }

}

export class ExpenseList{
  id: number;
  added_on: string;
  modified_on: string;
  active: boolean;
  compliance_status: any;
  added_by: number;
  is_cash: boolean;
  expense_bucket_category: number;
  expense_bucket: any;
  modified_by: number;
  transaction: any;
  expense_status: any;
  expense_type: any;
  report: number;
  merchant_name: string;
  reason: string;
  is_voilated: boolean;
  is_active: boolean;
  expense_attachments_count: any;
  is_track_expense: boolean;
  track_expense_detail: any;
  extra_fields_data: any;
  is_tax_included: boolean;
  is_upi:boolean=false;
  txn_type:string=''
  is_credit_applied: boolean;
  total_credit_amount: number;
  net_expense_amount: number;
}

export class ExpenseDetail{
  id: number;
  added_on: string;
  modified_on: string;
  active: boolean;
  compliance_status: any;
  added_by: any;
  is_cash: boolean;
  expense_bucket_category: number;
  expense_bucket: any;
  modified_by: number;
  expense_meta: any;
  transaction: any;
  expense_status: any;
  expense_type: any;
  report: any;
  merchant_name:string;
  reason: string;
  is_voilated: boolean;
  is_active: boolean;
  expense_attachments: any;
  expense_attachments_count: any;
  is_track_expense: boolean;
  track_expense_detail: any;
  extra_fields_data: any;
  is_tax_included: boolean;
  is_upi:boolean=false;
  verifier_name:string;
  approver_name:string;
  expense_tax_data=[];
  base_amount:number;
  vendor_details:any;
  approval:any;
  vendor_address_id: number;
  org_address_id: number;
  org_address_details: any;
  invoice_no: string;
  invoice_date: string;
  invoice_details: any;
  is_credit_applied: boolean;
  credit_details: CreditDetails;
}

export interface AppliedCredit {
  id?: number;
  credit_amount: number;
  amount_applied: number;
  txn_ref?: string;
  merchant?: string;
  credit_date?: string;
  notes?: string;
}

export interface CreditDetails {
  original_amount?: number;
  total_credits_applied?: number;
  net_expense_amount?: number;
  credits_count?: number;
  applied_credits?: AppliedCredit[];
  credit_amount?: number;
  amount_applied?: number;
  txn_ref?: string;
  credit_date?: string;
  notes?: string;
}
